import React from 'react';

import { request, checkStatus, toJSON } from '../../utils/request';
import { defaultLogo } from '../../assets/logos';
import { defaultBackground } from '../../assets/images';
import { Modal } from '../../components';
import { Languages } from '../../redux/modules/locale/types';
import * as logos from '../../assets/logos';
import * as backgrounds from '../../assets/images';

interface IProps {}
interface IState {
  name: string;
  background: any;
  logo: any;
  color: string;
  language: Languages;
}

const defaultValues: IState = {
  name: 'City Portal',
  background: defaultBackground,
  logo: defaultLogo,
  color: 'rgba(2, 56, 94, 0.7)',
  language: Languages.EN,
};

const ConfigContext = React.createContext(defaultValues);
const { REACT_APP_INSTANCE } = process.env;

export default class ConfigProvider extends React.Component<IProps, IState> {
  state: IState = {
    name: '',
    background: '',
    logo: '',
    color: '',
    language: Languages.EN,
  };

  async componentDidMount() {
    request(`instances-config/instanceId/${REACT_APP_INSTANCE}`)
      .then(checkStatus)
      .then(toJSON)
      .then(instance => {
        instance &&
          instance.length &&
          this.setState({
            ...instance[0],
          });
      })
      .catch(error => {
        console.error('Error during service worker registration:', error);
      });
  }

  render() {
    const logo = (logos as any)[this.state.logo];
    const background = (backgrounds as any)[this.state.background];
    return (
      <ConfigContext.Provider
        value={{
          ...this.state,
          ...(logo && { logo }),
          ...(background && { background }),
        }}
      >
        {this.props.children}
      </ConfigContext.Provider>
    );
  }
}

export const ConfigConsumer = ConfigContext.Consumer;
